<template>
    <v-expansion-panel>
        <v-expansion-panel-header>Zutaten</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row class="d-flex flex-wrap">
                <v-card v-for="(row, index) in postItem.recipe_container" v-bind:key="index" class="col-lg-2 col-sm-12 mr-3 mb-3">
                    <template>
                        <v-card-title>
                            <v-select :items="kindOfIngredient"
                                      label="Art"
                                      :value="row.content_type"
                                      v-model="row.content_type"
                            ></v-select>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field v-show="row.content_type == 1"  class="headlinerTitle" label="Überschrift" v-model="row.recipe_item" ></v-text-field>
                            <v-text-field v-show="row.content_type == 2"  label="Zutat" v-model="row.recipe_item" ></v-text-field>
                            <v-text-field v-show="row.content_type == 2" label="Menge" v-model="row.recipe_amount" ></v-text-field>
                            <v-select
                                    v-show="row.content_type == 2"
                                    :items="ingredientValue"
                                    label="Mengeneinheit"
                                    :value="row.recipe_unit"
                                    v-model="row.recipe_unit"
                            ></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <a @click="removeElementFromParts(index)" style="cursor: pointer"><v-icon>delete</v-icon></a>
                        </v-card-actions>
                    </template>
                </v-card>
            </v-row>
            <v-btn @click="addIngredientToArray">Zutat hinzufügen</v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
  export default {
    name: 'PostIngredientsComponent',
    props:['postItem'],
    beforeMount () {
      this.$forceUpdate();
    },
    data:() => {
      return {
        kindOfIngredient: [
          {text:'Headline', value:'1', selected:false},
          {text:'Zutat', value:'2', selected:false}
        ],
        ingredientValue:[
          {text:'',value:'0', selected:false},
          {text:'Blech',value:'1', selected:false},
          {text:'Esslöffel',value:'2', selected:false},
          {text:'Gramm',value:'3', selected:false},
          {text:'Kilogramm',value:'4', selected:false},
          {text:'Liter',value:'5', selected:false},
          {text:'Messerspitze',value:'6', selected:false},
          {text:'Milliliter',value:'7', selected:false},
          {text:'Portion',value:'8', selected:false},
          {text:'Prise',value:'9', selected:false},
          {text:'Stück',value:'10', selected:false},
          {text:'Teelöffel',value:'11', selected:false}
        ],
      }
    },
    methods:{
      addIngredientToArray: function(){
        this.postItem.recipe_container.push({
          record_id: 0,
          content_type: 0,
          recipe_item: '',
          recipe_amount: 0,
          recipe_unit: 0
        });
        this.$forceUpdate();
      },
      removeElementFromParts: function(index) {
        this.postItem.recipe_container.splice(index, 1);
      },
      updateView: function(){
        this.$forceUpdate();
      }
    }
  }
</script>

<style scoped>
    .headlinerTitle{
        margin-top:9em;
    }
</style>